import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
  Box,
  CheckboxCard,
  CheckboxGroup,
  Icon,
  SimpleGrid,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react';

const QUERY_KEY = key => `pub_${key}`;

const parseValuesFromUrl = (search, key) => {
  const params = new URLSearchParams(search);
  const raw = params.get(QUERY_KEY(key));

  if (!raw) return [];

  // expected format: has_any:premium,social
  const [, values] = raw.split(':');

  return values ? values.split(',') : [];
};

const formatValuesForUrl = (values, searchMode) =>
  values.length ? `${searchMode}:${values.join(',')}` : null;

const SearchFiltersMultiEnum = props => {
  const { id: key, enumOptions, filterConfig, updateQueryParams } = props;

  const { searchMode } = filterConfig;

  const location = useLocation();

  const checkboxFirst = useBreakpointValue({
    base: false,
    md: true,
  });

  // ---- LOCAL STATE (fast UI)
  const [selectedValues, setSelectedValues] = useState(() =>
    parseValuesFromUrl(location.search, key)
  );

  // ---- URL → STATE sync (back / forward / external updates)
  useEffect(() => {
    const fromUrl = parseValuesFromUrl(location.search, key);
    setSelectedValues(fromUrl);
  }, [location.search]);

  // ---- STATE → URL
  const handleChange = values => {
    setSelectedValues(values); // instant UI

    updateQueryParams({
      [QUERY_KEY(key)]: formatValuesForUrl(values, searchMode),
    });
  };

  return (
    <Box>
      <CheckboxGroup value={selectedValues} onValueChange={handleChange} orientation={'vertical'}>
        <SimpleGrid
          columns={{
            mdDown: 1,
            md: 2,
          }}
          gap={6}
        >
          {enumOptions.map(({ option, label }) => (
            <CheckboxCard.Root
              align="left"
              key={option}
              rounded={'xl'}
              value={option}
              size={'lg'}
              border={'none'}
              shadow={'none'}
              pl={0}
              pr={0}
              cursor="pointer"
            >
              <CheckboxCard.HiddenInput />
              <CheckboxCard.Control p={0}>
                {checkboxFirst && <CheckboxCard.Indicator rounded={'lg'} />}
                <CheckboxCard.Content>
                  <CheckboxCard.Label>{label}</CheckboxCard.Label>
                </CheckboxCard.Content>
                {!checkboxFirst && <CheckboxCard.Indicator rounded={'lg'} />}
              </CheckboxCard.Control>
            </CheckboxCard.Root>
          ))}
        </SimpleGrid>
      </CheckboxGroup>
    </Box>
  );
};

export default SearchFiltersMultiEnum;
